export const purchaseRequestPriorities = ['Red', 'Yellow', 'Green'];
